import React from 'react';
import { useUpload } from '../utils/uploadContext';
import { MdCloudUpload, MdCheck, MdError, MdClose } from 'react-icons/md';

const UploadIndicator = ({ onNavigateToUpload }) => {
  const { uploadProgress, uploadFileName, uploadStatus, cancelUpload } = useUpload();

  if (uploadProgress === null) return null;

  const getColor = () => {
    if (uploadStatus === 'done') return '#00c853';
    if (uploadStatus === 'failed') return '#ef4444';
    return '#00c853';
  };

  return (
    <div
      onClick={() => {
        if (uploadStatus !== 'done' && uploadStatus !== 'failed' && onNavigateToUpload) {
          onNavigateToUpload();
        }
      }}
      style={{
        position: 'fixed', bottom: '80px', left: '50%',
        transform: 'translateX(-50%)', zIndex: 9999,
        background: 'var(--bg-card)', border: `1px solid ${getColor()}`,
        borderRadius: '16px', padding: '16px 24px',
        boxShadow: `0 8px 32px rgba(0,0,0,0.4)`,
        minWidth: '320px', maxWidth: '480px',
        cursor: uploadStatus === 'uploading' ? 'pointer' : 'default'
      }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: uploadStatus === 'uploading' ? '10px' : '0' }}>
        {uploadStatus === 'done'
          ? <MdCheck style={{ color: '#00c853', fontSize: '20px', flexShrink: 0 }} />
          : uploadStatus === 'failed'
          ? <MdError style={{ color: '#ef4444', fontSize: '20px', flexShrink: 0 }} />
          : <MdCloudUpload style={{ color: getColor(), fontSize: '20px', flexShrink: 0 }} />
        }
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: '700', fontSize: '13px', color: 'var(--text-primary)' }}>
            {uploadStatus === 'done' ? '✅ Upload Complete!'
              : uploadStatus === 'failed' ? '❌ Upload Failed'
              : uploadProgress === 100 ? '🤖 Obsidian AI is publishing...'
              : `⬆️ Uploading ${uploadProgress}% — Click to view`}
          </div>
          <div style={{
            fontSize: '11px', color: 'var(--text-secondary)', marginTop: '2px',
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '280px'
          }}>
            {uploadFileName}
          </div>
        </div>
        {uploadStatus === 'uploading' && (
          <button
            onClick={(e) => { e.stopPropagation(); cancelUpload(); }}
            style={{
              background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)',
              color: '#ef4444', borderRadius: '8px', padding: '4px 8px',
              cursor: 'pointer', fontSize: '12px', fontWeight: '700',
              display: 'flex', alignItems: 'center', gap: '4px',
              flexShrink: 0, fontFamily: 'Inter, sans-serif'
            }}>
            <MdClose style={{ fontSize: '14px' }} /> Cancel
          </button>
        )}
      </div>
      {uploadStatus === 'uploading' && (
        <div style={{ height: '6px', background: 'var(--border)', borderRadius: '3px', overflow: 'hidden' }}>
          <div style={{
            height: '100%', width: `${uploadProgress}%`,
            background: 'linear-gradient(135deg, #00c853, #1de9b6)',
            borderRadius: '3px', transition: 'width 0.3s ease'
          }} />
        </div>
      )}
    </div>
  );
};

export default UploadIndicator;